import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SignatureCanvas from "react-signature-canvas";
import { Box, Button } from "@mui/material";
import { QUESTIONNAIRE_BUILDER } from "../../../locales/pages/namespaces";

const SignaturePad = ({ value, onChange,  readOnly = false }) => {
	const {t} = useTranslation(QUESTIONNAIRE_BUILDER);
	const sigPadRef = useRef(null);
	const lastValueRef = useRef(null);



	useEffect(() => {
		if (!sigPadRef.current) return;

		// Αν είναι το ίδιο value που μόλις έγραψε ο χρήστης → skip
		if (value && value === lastValueRef.current) return;
		// Ενημέρωση του signature pad με το νέο value
		if (value) {
			sigPadRef.current.clear();
			sigPadRef.current.fromDataURL(value);
		} else {
			sigPadRef.current.clear();
		}
	}, [value]);


	const handleEnd = () => {
		if (readOnly || !sigPadRef.current) return;

		if (sigPadRef.current.isEmpty()) {
			lastValueRef.current = "";
			onChange("");
			return;
		}

		const dataURL = sigPadRef.current.toDataURL("image/png");
		lastValueRef.current = dataURL;
		onChange(dataURL);
	};


	const handleClear = () => {
		if (readOnly) return;
		sigPadRef.current?.clear();
		onChange?.("");
	};

	return (
		<Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", flexDirection: "column", gap: 1, width: 200 }}>
			<SignatureCanvas
				ref={sigPadRef}
				penColor="black"
				// onEnd={handleEnd}
				onEnd={readOnly ? undefined : handleEnd}
				canvasProps={{
					width: 200,
					height: 90,
					style: {
						border: "1px solid rgb(75 84 135)",
						borderRadius: 10,
						pointerEvents: readOnly ? "none" : "auto",
					},
				}}
			/>

			<Button size="small" variant="outlined" disabled={readOnly} onClick={handleClear}>
				{t('Clear')}
			</Button>
		</Box>
	);
};

export default SignaturePad;
